import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_crm_dark.svg";
import lightModeLogo from "./logos/logo_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "BRL";

export const defaultTitle = "CRM";

// [hiperautomacao] Defaults in Portuguese. The deal stages, the pipeline
// (won) stages and the deal categories always come from the instance
// database (crm.configuration); these are only the offline fallback.
export const defaultCompanySectors = [
  { value: "arquitetura", label: "Arquitetura e design" },
  { value: "construcao", label: "Construção e incorporação" },
  { value: "imobiliario", label: "Imobiliário" },
  { value: "varejo", label: "Varejo" },
  { value: "industria", label: "Indústria" },
  { value: "logistica", label: "Logística" },
  { value: "servicos", label: "Serviços" },
  { value: "financeiro", label: "Financeiro" },
  { value: "governo", label: "Governo" },
  { value: "outro", label: "Outro" },
];

export const defaultDealStages = [
  { value: "novo_contato", label: "Novo contato" },
];

export const defaultDealPipelineStatuses: string[] = [];

export const defaultDealCategories = [
  { value: "entrada", label: "Entrada" },
  { value: "principal", label: "Principal" },
  { value: "high_ticket", label: "High ticket" },
  { value: "downsell", label: "Downsell" },
  { value: "upsell", label: "Upsell" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frio", color: "#7dbde8" },
  { value: "warm", label: "Morno", color: "#e8cb7d" },
  { value: "hot", label: "Quente", color: "#e88b7d" },
  { value: "in-contract", label: "Fechando", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Nenhum" },
  { value: "call", label: "Ligar" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "E-mail" },
  { value: "meeting", label: "Reunião" },
  { value: "visit", label: "Visita" },
  { value: "follow-up", label: "Retorno" },
  { value: "proposal", label: "Enviar proposta" },
  { value: "thank-you", label: "Agradecer" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
